import {
  getDownloadURL,
  getStorage,
  ref,
  uploadString,
} from 'firebase/storage';
import { flow } from 'mobx';
import { picturesMaxSize } from '../../config';
import resizeImageFile from '../../helpers/resizeImageFile';
import UserImplDependedRefState from './abstract/UserImplDependedRefState';

class ProfileState extends UserImplDependedRefState {
  constructor(root) {
    super(root, { pathGetter: (userImpl) => `profiles/${userImpl.uid}` });
  }

  handleSnapshotSuccess(snapshot) {
    super.handleSnapshotSuccess(snapshot);
    if (!snapshot.exists()) {
      this.error = "Profile doesn't exists";
    }
  }

  *updateProfilePicture(file) {
    this.isUpdating = true;

    let downloadUrl;

    try {
      const fileRef = ref(
        getStorage(),
        `profileImages/${this.data.profileUid}`
      );
      const base64ResizedImage = yield resizeImageFile(
        file,
        picturesMaxSize.profile,
        picturesMaxSize.profile
      );
      yield uploadString(fileRef, base64ResizedImage, 'data_url');
      downloadUrl = yield getDownloadURL(fileRef);
    } catch (e) {
      this.isUpdating = false;
      return Promise.reject(e);
    }

    return this.update({
      imageUrl: downloadUrl,
    });
  }
}

ProfileState.annotations = {
  ...UserImplDependedRefState.annotations,
  updateProfilePicture: flow,
};

export default ProfileState;
